import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'

// PLOP_APPEND_PATTERN_ANCHOR

export function getGoogleAdManagerAdUnitsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.googleAdManagerAdUnits
  })
}

export function getGoogleAdManagerAdUnitService({ id, ...params }) {
  return madeRequest('GET', {
    params,
    url: `${ENDPOINTS.googleAdManagerAdUnits}${id}`
  })
}

export function getOnsiteRatesService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.onsiteRates
  })
}

export function createBulkGamLineItemsService(data) {
  return madeRequest('POST', {
    data,
    url: ENDPOINTS.googleAdManagerLineItemsBulkCreate
  })
}

export function createGamLineItemForecastService(data) {
  return madeRequest('POST', {
    data,
    url: ENDPOINTS.googleAdManagerLineItemsForecast
  })
}

export function getGamAdUnitSizesService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.gamAdUnitSizes
  })
}
